import { render, staticRenderFns } from "./OurOrganisation.vue?vue&type=template&id=8787c45c&scoped=true&"
import script from "./OurOrganisation.vue?vue&type=script&lang=js&"
export * from "./OurOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./OurOrganisation.vue?vue&type=style&index=0&id=8787c45c&scoped=true&lang=css&"
import style1 from "./OurOrganisation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8787c45c",
  null
  
)

export default component.exports